import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="w-full h-full flex-1 flex flex-col items-center justify-center">
      <div className="w-full lg:w-6/12 mx-auto">
        <DotLottieReact src="/assets/lottie/404.json" loop autoplay />
      </div>
      <p className="mt-10 text-center text-xl font-rokh font-[700]">
        داریم این اتاق رو ضدعفونی می‌کنیم، <br /> لطفا برید سالن اصلی کارمون
        تموم شد خبر می‌دیم.
      </p>
      <Link to="/" className="btn btn-outline btn-wide mx-auto my-6">
        صفحه اصـــلی
      </Link>
    </div>
  );
};

export default NotFound;
